import { useContext, useRef,useEffect ,useState } from "react";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "./CustomForm.module.scss";
import ScrollDown from "../../components/ScrollDown/ScrollDown";
import { ApplicationContext } from "../../context/ApplicationContext";
import { useRouter } from "next/dist/client/router";
import { Controller, useForm } from "react-hook-form";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactDOMServer from "react-dom/server";
import CloseIcon from "../../public/assets/icons/closeIcon.svg";
import Swal from "sweetalert2";
import Input from "../Input/Input";


const CustomForm = ({ dataContent, styletype }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
  } = useForm();

  const router = useRouter();
  const { setShowLoader } = useContext(ApplicationContext);

  const onSubmit = async (data) => {
    console.log('submit data', data);
    setShowLoader(true);
    let baseUrl = `${process.env.NEXT_PUBLIC_DATA_BASEURL}`;
    let url = baseUrl.replace("wp-json", router.query.locale + "/wp-json");
    url = dataContent.action;
    let lang = 'en';
    if( router.query.locale == 'it' )
      lang = 'it';

    let postdata = {};
    postdata['lang'] = lang;

    for(let k in dataContent.fields) {
      if(dataContent.fields[k].type == 'phone_separated') {
        let phoneArr = data[dataContent.fields[k].name].replace('+', '').split(' ');
        postdata[dataContent.fields[k].name] = {
          'country_code': phoneArr[0],
          'number': phoneArr[1]
        }
      }
      else {
        postdata[dataContent.fields[k].name] = data[dataContent.fields[k].name];
      }
    }

    //console.log('postData', postdata);
   
   
    const res = await fetch(
      url,
      {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postdata),
      }
    );
    const resjs = await res.json();
    console.log('resjs', resjs);
    let message = (resjs.message == 'CUSTOM_FORM_KO' || (resjs.hasOwnProperty('code') && resjs.code == 'rest_missing_callback_param') ) ? dataContent.error_message : dataContent.success_message;
    
    if(resjs.message != 'CUSTOM_FORM_KO') {
      if( typeof fbq == 'function' && (document.location.pathname == '/it/eventi/concorso-di-natale/'
        || document.location.pathname == '/en/events/christmas-contest/'
        || document.location.pathname == '/it/eventi/concorso-di-natale'
        || document.location.pathname == '/en/events/christmas-contest') ) {
          fbq('track', 'Lead');
        }
    }
    setShowLoader(false);
    Swal.fire({
      title: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
    });
  };


  return (
    <div className={styles.formContainer + (styletype == 'gold' ? ' '+styles.goldForm : '')}>
      <div className="centeredSection">
      <form onSubmit={handleSubmit(onSubmit)} className={styles.Form}>
      {dataContent.fields.map(field => {
        if(field.type == 'text') {
          return(<label key={field.name}>
            <input
              className={styles.bordered}
              placeholder=" "
              type={'text'}
              {...register(field.name, {
                required: field.required/*,
                pattern:
                  /[a-zA-ZÀ-ž]{1}[\sa-zA-ZÀ-ž\-']{1,500}$/,*/
              })}
            />
            <span>{field.label}</span>
            {errors[field.name] &&
              <div className={styles.error}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
                &nbsp;
                {field.error_message}
              </div>
            }
          </label>);
        }
        else if(field.type == 'hidden') {
          return(<span key={field.name} style={{display: 'none'}}>
            <input
              placeholder=" "
              type={'hidden'}
              {...register(field.name, {
                required: field.required,
              })}
              value={field.label}
            />
          </span>);
        }
        else if(field.type == 'email') {
          return(<label key={field.name}>
            <input
              className={styles.bordered}
              placeholder=" "
              type={field.type}
              {...register(field.name, {
                required: field.required,
                pattern: /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/,
              })}
            />
            <span>{field.label}</span>
            {errors[field.name] &&
              <div className={styles.error}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
                &nbsp;
                {field.error_message}
              </div>
            }
          </label>);
        }
        else if(field.type == 'checkbox') {
          return(<label key={field.name} className={styles.checkboxlabel}>
            <input
              placeholder=" "
              type={field.type}
              {...register(field.name, {
                required: field.required
              })}
            />
            <span dangerouslySetInnerHTML={{__html: field.label}}></span>
            {errors[field.name] &&
              <div className={styles.error}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
                &nbsp;
                {field.error_message}
              </div>
            }
          </label>);
        }
        else if(field.type == 'phone' || field.type == 'phone_separated') {
          return(<div key={field.name} className={styles.phoneField}>
            <Controller
              control={control}
              name={field.name}
              rules={{required: field.required}}
              render={({ field: { onChange, value } }) => (
                <Input 
                  name="phone"
                  type="phone"
                  phone={true}
                  phoneSplit={true}
                  placeholder={field.label}
                  setPhone={v => { onChange({ target: {value: v}}) }}
                  error={field.error_message}
                  errorCheck={errors[field.name]}
                  value={value}
                />
              )} />
          </div>);
        }
        else if(field.type == 'submit') {
          return (<div style={{textAlign: 'center'}}><input type="submit" value={field.label} /></div>);
        }
        else if(field.type == 'info_message') {
          return(<div key={field.name} className={styles.infoMessage} dangerouslySetInnerHTML={{__html: field.text}}>
          </div>);
        }
      })}
        
      </form>
      </div>
    </div>
  );
}

export default CustomForm;